<template>

    <div class="container">

        <div class="handle-box-search">

            <div class="handle-box">

                <el-row class="head-search">

                    <el-col :span="8">
                        <span class="title">商家名称:</span>
                        <!-- 搜索商家名称 -->
                        <el-input v-model="search_data.name" placeholder="请输入商家名称" class="handle-input mr10"
                            @keyup.enter.native="searchBusinessLists"></el-input>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">商家手机号:</span>
                        <!-- 搜索商家手机号 -->
                        <el-input v-model="search_data.phone" placeholder="请输入商家手机号" class="handle-input mr10"
                            @keyup.enter.native="searchBusinessLists"></el-input>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">联系人姓名:</span>
                        <!-- 搜索联系人姓名 -->
                        <el-input v-model="search_data.linkman" placeholder="请输入联系人姓名" class="handle-input mr10"
                            @keyup.enter.native="searchBusinessLists"></el-input>
                    </el-col>



                </el-row>

                <el-row class="head-search">

                    <el-col :span="8">
                        <span class="title">绑定状态:</span>

                        <el-select v-model="search_data.bind_status" placeholder="请选择绑定状态" clearable
                            @keyup.enter.native="searchBusinessLists">
                            <el-option label="已绑定" value="1">
                            </el-option>
                            <el-option label="未绑定" value="0">
                            </el-option>

                        </el-select>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">分润模式:</span>

                        <el-select v-model="search_data.type" placeholder="请选择分润模式" clearable
                            @keyup.enter.native="searchBusinessLists">
                            <el-option label="百分比" value="1">
                            </el-option>
                            <el-option label="金额" value="0">
                            </el-option>

                        </el-select>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">审核状态:</span>

                        <el-select v-model="search_data.audit_status" placeholder="请选择审核状态" clearable
                            @keyup.enter.native="searchBusinessLists">

                            <el-option label="待审核" value="0">
                            </el-option>

                            <el-option label="通过" value="1">
                            </el-option>
                            <el-option label="驳回" value="2">
                            </el-option>

                        </el-select>
                    </el-col>
                </el-row>
                <el-row class="head-search">
                    <el-col :span="24" style="margin-top: 10px;">
                        <span class="title">创建时间:</span>

                        <el-date-picker v-model="search_time" type="datetimerange" range-separator="-"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange" style="width: 300px;">
                        </el-date-picker>
                    </el-col>
                </el-row>
            </div>



            <el-button type="primary" icon="el-icon-search" @click="searchBusinessLists">搜索</el-button>
            <el-button @click="add_isShow=!add_isShow">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
            <el-button @click="toExport" v-else>导出</el-button>
            <el-button @click="record_isShow=!record_isShow">导出记录</el-button>

        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header"
            @selection-change="handleSelectionChange">

            <el-table-column type="selection" width="55">
            </el-table-column>




            <el-table-column prop="business_code" label="商家码" min-width="130">
                <template slot-scope="scope">
                    <el-image style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 5px;"
                        :src="scope.row.reward_qrcode" v-if="scope.row.reward_qrcode!=''" :preview-src-list="srcList">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column label="编码" prop="business_code" min-width="130">
            </el-table-column>

            <el-table-column label="创建时间" prop="created_at" min-width="100">
            </el-table-column>

            <el-table-column prop="order_mode_code" label="计费模式" min-width="150">
                <template slot-scope="scope">
                    {{scope.row.order_mode}}
                </template>
            </el-table-column>

            <el-table-column label="绑定状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.name==!''?'success':'danger'">
                        {{scope.row.name == ''?'未绑定':'已绑定'}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="type" label="分润模式">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.type=='0'?'warning':(scope.row.type=='1'?'':'danger')">
                        {{scope.row.type == '1'?'百分比':'金额'}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="商家名称" prop="name" min-width="180">
            </el-table-column>

            <el-table-column prop="phone" label="手机电话" min-width="120">
            </el-table-column>

            <el-table-column prop="head_img" label="门店图片" min-width="130">
                <template slot-scope="scope">
                    <el-image style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 5px;"
                        :src="scope.row.head_img" v-if="scope.row.head_img!=''" :preview-src-list="srcList">
                    </el-image>
                </template>
            </el-table-column>

            <el-table-column label="联系人姓名" prop="linkman" min-width="130">
            </el-table-column>

            <el-table-column label="可提现金额" prop="withdrawal">
            </el-table-column>

            <el-table-column label="扫码下单次数" prop="order_num">
            </el-table-column>

            <el-table-column label="审核状态">
                <template slot-scope="scope">
                    <el-tag
                        :type="scope.row.audit_status=='0'?'warning':(scope.row.audit_status=='1'?'success':'danger')">
                        {{scope.row.audit_status == '0'?'待审核':scope.row.audit_status == '1'?'通过':'驳回'}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status=='1'?'success':'danger'">
                        {{scope.row.status == '1'?'启用':'禁用'}}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">

                    <!-- 编辑按钮 -->
                    <el-button type="primary" size="mini" margin-right:5px
                        @click="edit_isShow = !edit_isShow; business_code = scope.row.business_code; " trigger="click">

                        编辑



                    </el-button>


                    <!-- 查看按钮 -->
                    <el-button type="primary" size="mini"
                        @click="view_isShow = !view_isShow; business_code = scope.row.business_code">查看</el-button>



                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加组件 -->
        <addBusinessDrawer :isShow="add_isShow" @onSubmit="businessLists"></addBusinessDrawer>

        <!-- 编辑组件 -->
        <editBusinessDrawer :isShow="edit_isShow" :data="business_code" @onSubmit="businessLists"></editBusinessDrawer>

        <!-- 查看组件 -->
        <viewBusinessDrawer :isShow="view_isShow" :data="business_code"></viewBusinessDrawer>

        <!-- 导出记录组件 -->
        <recordBusinessDrawer :isShow="record_isShow" :data="business_code"></recordBusinessDrawer>



    </div>
</template>

<script>
    var _this;
    import addBusinessDrawer from './addBusinessDrawer.vue';
    import editBusinessDrawer from './editBusinessDrawer.vue';
    import viewBusinessDrawer from './viewBusinessDrawer.vue';
    import recordBusinessDrawer from './recordBusinessDrawer.vue';
    import axios from 'axios'; // AJAX封装类
    import {
        config
    } from '@/utils/config'; //配置
    export default {
        components: {
            addBusinessDrawer,
            editBusinessDrawer,
            viewBusinessDrawer,
            recordBusinessDrawer
        },
        data() {
            return {

                loading: false,

                srcList: [],

                search_time: '',

                business_code: '',

                add_isShow: false,

                edit_isShow: false,

                view_isShow: false,
                
                record_isShow: false,

                // 存放表格数据
                tableData: [],



                //获取用户列表的数据
                search_data: {
                    page: 1,
                    limit: 10,
                    name: '',
                    phone: '',
                    linkman: '',
                    created_at: '',
                    bind_status: '',
                    type: '',
                    audit_status: '',
                    status: '',
                    business_code_array: ''

                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                }
            };
        },
        created() {
            _this = this;
            _this.businessLists();
        },

        methods: {

            // 导出
            toExport() {

                _this.loading = true;
                _this.businessListExportExcel();
                

            },
            // 导出任务创建
            businessListExportExcel() {
                
                _this
                    .$post('/business/businessListExportExcel', _this.search_data, _this.search_rules)
                    .then((res) => {
                        this.$message.success(res.msg);
                        _this.loading = false;


                    })
                    .catch((err) => {});
            },


            // 全选或多选
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log(this.multipleSelection);

                var datalist = [];

                for (var i in val) {

                    datalist.push(val[i].business_code);

                }
                _this.search_data.business_code_array = datalist;
                console.log(datalist);

            },
            timeChange(val) {
                console.log(val);

                if (val != null) {
                    _this.search_data.created_at = JSON.stringify(['between', ..._this.search_time])
                } else {
                    _this.search_data.created_at = ''
                }


            },

            searchBusinessLists() {
                _this.search_data.page = 1;
                _this.businessLists();
            },

            businessLists() {
                _this
                    .$post('/business/businessList', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;
                        _this.srcList.length = 0;
                        for (let i = 0; i < res.data.length; i++) {

                            _this.srcList.push(res.data[i].head_img)
                            _this.srcList.push(res.data[i].reward_qrcode)

                        }


                    })
                    .catch((err) => { });
            },
            //翻页组件的回调
            pages_function(search_data) {
                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.businessLists();
            },



            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }



        }

    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        max-width: 150px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown+.el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>